import DOMPurify from "dompurify";

// Strict allow-list: only inline formatting tags + safe attributes.
// Translations may contain <strong>, <em>, <span class="..."> and <a href="..."> tags.
const CONFIG = {
  ALLOWED_TAGS: ["a", "strong", "em", "b", "i", "u", "span", "br"],
  ALLOWED_ATTR: ["href", "target", "rel", "class", "data-testid"],
  ALLOW_DATA_ATTR: false,
};

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("rel", "noopener noreferrer");
    if (!node.getAttribute("target")) {
      node.setAttribute("target", "_blank");
    }
  }
});

export function sanitizeHtml(input) {
  if (input == null) return "";
  return DOMPurify.sanitize(String(input), CONFIG);
}

export function safeHtml(input) {
  return { __html: sanitizeHtml(input) };
}
